var map = {
	"./FeatureItem1.svg": 8842,
	"./FeatureItem2.svg": 3865,
	"./FeatureItem3.svg": 8472,
	"./FeatureItem4.svg": 7655,
	"./FeatureItem5.svg": 3830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5419;